import $ from 'jquery';

export const VideoModal = (function () {
	'use strict';

	let $videoPreview, $videoModal;

	function init() {
		$videoPreview = $('.video-modal-preview, .video-modal-link');
		$videoModal = $('#video-modal');

		$videoPreview.click(openVideoModal);

		$('.modal__close').click(closeModal);

		$('.modal').on('click', function (e) {
			if ($(e.target).closest('.modal__content').length === 0) {
				closeModal();
			}
		});
	}

	function openVideoModal(ev) {
		ev.preventDefault();
		$('body').addClass('modal--active');

		let $iframe = $(this).find('iframe');
		let autoplaySrc = $iframe.attr('src') + '&autoplay=1';

		$videoModal.find('.iframe-container').html($iframe.clone());
		$videoModal.find('iframe').attr('src', autoplaySrc);

		$videoModal.addClass('modal--active');
	}

	function closeModal() {
		$('.modal--active').removeClass('modal--active');
		$videoModal.find('.iframe-container').empty();
	}

	return {
		init: init,
	};
})();
